import React from 'react';
import Style from './listTicketOffices.module.css';
import { ButtonDropdown, Button, DropdownItem, CardRow, Icon, Tooltip, toast } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import ConfirmModal from '../../../components/confirmModal';
import { fetcher } from '@weezevent/weezjs-core';
import { useHistory } from 'react-router-dom';

const RightComponent = ({ ticket_office, organization, syncTicketOffices }) => {
    const history = useHistory();

    const [displayModal, setDisplayModal] = React.useState(false);
    const { t } = useTranslation();
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const onDelete = React.useCallback(() => {
        setIsSubmitting(true);
        fetcher
            .delete(`/ticket/organizations/${organization.id}/ticket_office/${ticket_office.id}`)
            .then(() => toast.success(t('ticket.ticket_offices.delete.sucess')))
            .catch(err => {
                toast.error('ticket.ticket_offices.delete.failed');
            })
            .finally(() => {
                syncTicketOffices({
                    allow_cache: false,
                    cache: false
                });
                setDisplayModal(false);
                setIsSubmitting(false);
            });
    }, [setDisplayModal, setIsSubmitting, organization, ticket_office]);

    return (
        <CardRow.RightComponent className={Style['ticketoffices-line-actions-buttons']}>
            {displayModal && (
                <ConfirmModal
                    labelTitle={t('ticket.ticket_offices.deleteModal.title')}
                    labelBody={t('ticket.ticket_offices.deleteModal.body', { name: ticket_office.name })}
                    objectToSave={displayModal}
                    onClose={() => setDisplayModal(false)}
                    onAccept={onDelete}
                    isSubmitting={isSubmitting}
                    disabled={isSubmitting}
                    destructive
                />
            )}
            <div className={Style['ticketoffices-icon-button-container']}>
                <Tooltip title={t('ticket.ticket_offices.Icon.FstHover')} triggerOnHover visible className={Style['rm-margin-on-tooltip']}>
                    <CardRow.IconButton as="a" href={`/ticket/O${organization.id}/ticket_offices/${ticket_office.id}/settings`} icon={<Icon name="cog" margin={false} />} />
                </Tooltip>
                <Tooltip title={t('ticket.ticket_offices.Icon.SndHover')} triggerOnHover visible className={Style['rm-margin-on-tooltip']}>
                    <CardRow.IconButton
                        as="a"
                        href={`/ticket/O${organization.id}/ticket_offices/${ticket_office.id}/reports/salesjournal`}
                        icon={<Icon name="chart" margin={false} />}
                    />
                </Tooltip>
                <Tooltip title={t('ticket.ticket_offices.Icon.ThdHover')} triggerOnHover visible className={Style['rm-margin-on-tooltip']}>
                    <CardRow.IconButton as="a" href={`/ticket/O${organization.id}/ticket_offices/${ticket_office.id}/users`} icon={<Icon name="user" margin={false} />} />
                </Tooltip>
            </div>
            <div className={Style['dropdown-button-items']}>
                <ButtonDropdown
                    renderWhenClosed
                    trigger={<Button inverted primary iconPosition="right" icon={<Icon name="chevron-bottom" />} label={t('ticket.common.cta.actions')} />}
                    items={[
                        <div key="items">
                            <div key="actions">
                                <DropdownItem
                                    key="handle_events"
                                    className={Style['dropdown_item']}
                                    item={t('ticket.ticket_offices.dropdown_menu.handle_events')}
                                    onClick={() => history.push(`/ticket/O${organization.id}/ticket_offices/${ticket_office.id}/events`)}
                                />
                                <DropdownItem.Line />
                                <DropdownItem
                                    key="delete"
                                    className={Style['dropdown_item_content']}
                                    item={t('ticket.common.action.delete')}
                                    deleteItem
                                    onClick={() => setDisplayModal(true)}
                                />
                            </div>
                        </div>
                    ]}
                />
            </div>
        </CardRow.RightComponent>
    );
};

const LeftComponent = ({ ticket_office, organization, syncTicketOffices }) => {
    const history = useHistory();
    const goToModify = React.useCallback(() => {
        history.push(`/ticket/O${organization.id}/ticket_offices/${ticket_office.id}/dashboard`);
    }, [history, organization, ticket_office]);
    return (
        <CardRow.LeftComponent onClick={goToModify} className={Style['ticketoffices-line-title-container']}>
            <div className={Style['ticketoffices-line-title']}>{ticket_office.name}</div>
        </CardRow.LeftComponent>
    );
};

const TicketOfficesLine = ({ ticket_office, organization, syncTicketOffices }) => {
    return (
        <CardRow className={Style['card_content']}>
            <LeftComponent ticket_office={ticket_office} organization={organization} syncTicketOffices={syncTicketOffices} />
            <RightComponent ticket_office={ticket_office} organization={organization} syncTicketOffices={syncTicketOffices} />
        </CardRow>
    );
};

export default TicketOfficesLine;
